import Header from "../navigation/header";
import {
  StyleSheet,
  TouchableOpacity,
  Modal,
  Button,
  Switch,
  TextInput as TextInputRN,
  FlatList,
  Alert,
  ScrollView,
  SafeAreaView,
  ActivityIndicator,
  Dimensions,
} from "react-native";
import { useFocusEffect } from "@react-navigation/native";
import { Dropdown } from "react-native-element-dropdown";
import { DatePickerModal } from "react-native-paper-dates";

import { Text, View } from "../../components/Themed";
import { RootStackScreenProps } from "../../types"; 
import Icon from "react-native-vector-icons/AntDesign";
import IconEdit from "react-native-vector-icons/FontAwesome";
import IconEye from "react-native-vector-icons/Entypo";
import React, { useEffect, useState, useMemo, useRef } from "react";
import IconCross from "react-native-vector-icons/Entypo";
import AsyncStorage from "@react-native-async-storage/async-storage";
import AwesomeAlert from "react-native-awesome-alerts";
import { TextInput } from "react-native-paper";
import { baseUrl, postData } from "../../networking/api";
import { Provider as PaperProvider } from "react-native-paper";
import { Item } from "react-native-paper/lib/typescript/components/List/List";
import DataTable from "react-data-table-component";
import { useSelector } from "react-redux";
import moment from "moment";
import CustomSwitch from "../../components/CustomSwitch";
import Svg, { G, Circle, Rect } from "react-native-svg";
import Victory from "../../constants/victory";
import { StackedBarChart } from "react-native-chart-kit";
import IconFontAwesome from "react-native-vector-icons/FontAwesome";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import IconRefresh from "react-native-vector-icons/FontAwesome";

const windowWidth = Dimensions.get("window").width;
const windowHeight = Dimensions.get("window").height;

export default function Program({ navigation }) {
  const [isLoadingSync, setIsLoadingSync] = useState(true);

  const [isVisible, setIsVisible] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [OmegeDeviceIds, setOmegeDeviceId] = useState();
  const [isAdd, setisAdd] = useState(false);
  var [counter, setCounter] = useState(1);
  const [sort, setsort] = useState(0);
  const [editpopup, setEditPopup] = useState(false);
  const [popid, setpopid] = useState("");
  const [popindex, setpopindex] = useState("");
  const [projectId, setProjectId] = useState("");
  const [projectCodeID, setProjectCode] = useState("");

  const [OmegaIdData, setOmegaIdData] = useState([]);
  const [OmegavalueId, setOmegaValueiD] = useState("");
  const [OmegaId, setOmegaId] = useState("");

  const [OmegaIdValue, setOmegaIdValue] = useState(null);
  const [OmegaError, setOmegaError] = useState("");
  const [isFocus, setIsFocus] = useState(false);

  const [graphOmegavalueId, setGraphOmegaValueiD] = useState("");
  const [graphOmegaId, setGraphOmegaId] = useState("");

  const [graphOmegaIdValue, setGraphOmegaIdValue] = useState(null);
  const [graphOmegaError, setGraphOmegaError] = useState("");
  const [isgraphFocus, setGraphIsFocus] = useState(false);

  const [alertTypeValue, setAlertTypeValue] = useState("");

  var idProject = useSelector((state) => state.idUpdating);
  var projectCodeId = useSelector((state) => state.projectCodeId);

  const [showAlert, setAlert] = useState(false);
  const [isOmegeDeviceNameValid, setOmegeDeviceNameDataValid] = useState(false);
  const [isOmegeDeviceNameEntered, setOmegeDeviceNameDataEntered] =
    useState(false);
  const [OmegeDeviceName, setOmegeDeviceNameData] = useState([]);
  const [OmegeDeviceByName, setOmegeDeviceByName] = useState("");
  const [error, setError] = useState("");
  const textOmegeDeviceName = useRef("");
  const [OmegeDeviceLength, setOmegeDeviceLength] = useState(0);
  const [searchData, setSearch] = useState("");
  const [filterData, setFilteredDataSource] = useState([]);
  const [IsReportSynce, setIsReportSynce] = useState(false);

  const [alertData, setAlertData] = useState([
    {
      name: "All",
      value: "",
    },
    {
      name: "General Error",
      value: "general_error",
    },
    {
      name: "Reset Reason",
      value: "unit_reset",
    },
    {
      name: "Low Battery",
      value: "low_battery",
    },
    {
      name: "Critical Low Battery",
      value: "critical_low_battery",
    },
    {
      name: "Modem Error",
      value: "modem_error",
    },
    {
      name: "SIM Error",
      value: "general_error",
    },
    {
      name: "RSSI + Cellular provider",
      value: "general_error",
    },
    {
      name: "Start FOTA",
      value: "start_fota",
    },
    {
      name: "End FOTA",
      value: "end_fota",
    },
    {
      name: "Modem Connect",
      value: "modem_connect",
    },
    {
      name: "Modem Disconnect",
      value: "modem_disconnect",
    },
    {
      name: "Configuration Error",
      value: "configuration_error",
    },
    {
      name: "Unit Started",
      value: "unit_started",
    },
    {
      name: "Program enqueue",
      value: "program_enqueue",
    },
    {
      name: "Program dequeued",
      value: "program_dequeued",
    },
    {
      name: "Capacitor failure",
      value: "capacitor_failure",
    },
    {
      name: "battery check",
      value: "battery_voltage",
    },
    {
      name: "Analog Error28",
      value: "analog_error",
    },
    {
      name: " Unit disconnect from the server",
      value: "unit_started",
    },
    {
      name: "Modbus Error",
      value: "program_enqueue",
    },
    {
      name: "Open Valve",
      value: "valve_open",
    },
    {
      name: "Close Valve",
      value: "valve_close",
    },
    {
      name: "Open Fertigation",
      value: "fertigation_open",
    },
    {
      name: "Close Fertigation",
      value: "fertigation_close",
    },
  ]);

  const [isPressAlert, setIsPressAlert] = useState(false);
  const [isPressOmega, setIsPressOmega] = useState(true);

  const [FromDateError, setFromDateError] = useState("");
  const [ToDateError, setToDateError] = useState("");

  const optionsPerPage = [10, 25, 50, 100];

  const [page, setPage] = React.useState(0);
  const [itemsPerPage, setItemsPerPage] = React.useState(optionsPerPage[0]);
  const from = page * itemsPerPage;
  const to = Math.min((page + 1) * itemsPerPage, OmegeDeviceLength);
  const screenwidth = Dimensions.get("window").width;
  const isMobile = screenwidth < 768;

  React.useEffect(() => {
    setIsPressOmega(true);
    setPage(0);
    setpopindex("");
    setEditPopup(false);
    setpopid("");
  }, [itemsPerPage]);
  const isCreatable = () => {
    setIsVisible(true);
    setisAdd(true);
  };

  var alpha_pattern = new RegExp(/^[a-zA-Z]+(\s[a-zA-Z]+)?$/);

  const [FromDate, setFromDate] = React.useState<Date | undefined>(new Date());
  const [FromOpen, setFromOpen] = React.useState(false);
  const [isGraphicalViewOpen, setisGraphicalViewOpen] = React.useState(false);

  const [graphFromDate, setGraphFromDate] = React.useState<Date | undefined>(
    new Date(),
  );
  const [graphFromOpen, setGraphFromOpen] = React.useState(false);

  const [graphToDate, setGraphToDate] = React.useState<Date | undefined>(
    new Date(),
  );
  const [graphToOpen, setGraphToOpen] = React.useState(false);

  const [graphFromDateError, setGraphFromDateError] = useState("");
  const [graphToDateError, setGraphToDateError] = useState("");

  const [programGraphData, setProgramGraphData] = useState({});
  const [isFetched, setIsFetched] = useState(false);

  const onSelectSwitch = (index) => {
    if (isGraphicalViewOpen) {
      setOmegaId("");
      setGraphOmegaId("");
      setisGraphicalViewOpen(false);
    } else {
      setOmegaId("");
      setGraphOmegaId("");
      setisGraphicalViewOpen(true);
    }
  };

  const onDismissGraphFrom = React.useCallback(() => {
    setGraphFromOpen(false);
  }, [setGraphFromOpen]);

  const onConfirmGraphFrom = React.useCallback(
    (params: { date: React.SetStateAction<Date | undefined> }) => {
      setGraphFromOpen(false);
      setGraphFromDateError("");
      setGraphFromDate(params.date);
    },
    [setGraphFromOpen, setGraphFromDate],
  );

  const onDismissGraphTo = React.useCallback(() => {
    setGraphToOpen(false);
  }, [setGraphToOpen]);

  const onConfirmGraphTo = React.useCallback(
    (params: { date: React.SetStateAction<Date | undefined> }) => {
      setGraphToOpen(false);
      setGraphToDateError("");
      setGraphToDate(params.date);
    },
    [setGraphToOpen, setGraphToDate],
  );

  const onDismissFrom = React.useCallback(() => {
    setFromOpen(false);
  }, [setFromOpen]);

  const onConfirmFrom = React.useCallback(
    (params: { date: React.SetStateAction<Date | undefined> }) => {
      setFromOpen(false);
      setFromDateError("");
      setFromDate(params.date);
      checkForm();
    },
    [setFromOpen, setFromDate],
  );

  const checkForm = () => {};
  const [ToDate, setToDate] = React.useState<Date | undefined>(new Date());
  const [ToOpen, setToOpen] = React.useState(false);

  const onDismissTo = React.useCallback(() => {
    setToOpen(false);
  }, [setToOpen]);

  const onConfirmTo = React.useCallback(
    (params: { date: React.SetStateAction<Date | undefined> }) => {
      setToOpen(false);
      setToDateError("");
      setToDate(params.date);
    },
    [setToOpen, setToDate],
  );

  const dropdownRefOmegaiD = useRef();
  const closeMenu = () => {
    dropdownRefOmegaiD.current.close();
  };

  useEffect(() => {
    window.addEventListener("scroll", closeMenu);
    return () => window.removeEventListener("scroll", closeMenu);
  }, []);

  useEffect(() => {
    getOmegaDeviceData(OmegaId);
  }, [FromDate, ToDate, IsReportSynce]);

  useEffect(() => {
    getProgramGraphData(graphOmegaId);
  }, [graphFromDate, graphToDate]);

  

  useFocusEffect(
    React.useCallback(() => {
      
      getAdminData();
      setIsPressOmega(true);
      searchFilterFunction("");
    }, []),
  );

  const getAdminData = async () => {
    let jsonValue = await AsyncStorage.getItem("userData");
    let proCodeId = await AsyncStorage.getItem("projectCode");
    let proCode = JSON.parse(proCodeId);

    setProjectCode(proCode);
    
    let projValue = await AsyncStorage.getItem("projectData");

    if (projValue != null) {
      setProjectId(projValue);
      getOmegaDependentByProjectId(projValue);
    } else if (jsonValue != null) {
      var userDetailsresponse = JSON.parse(jsonValue);

      setProjectId(userDetailsresponse.project_selected);
      getOmegaDependentByProjectId(userDetailsresponse.project_selected);
    }
  };

  const getDownloadExcel = async () => {
    
    const filteredData = OmegeDeviceName.map(
      (
        {
          unitName,
          programName,
          valveName,
          zone_name,
          sub_zone_name,
          startDate,
          startTime,
          endDate,
          endTime,
          amountType,
          amountPlanned,
          executionTime,
          leftover,
          amount,
          __typename,
          openReason,
          closeReason,
          valveOpenReason,
          valveCloseReason,
          leakageFlow,
          fertigations,
        },
        index,
      ) => ({
        "Sr No": index + 1,
        "Omega Name": unitName,
        "Program Name": programName,
        "Valve Name": valveName,
        "Zone Name": zone_name,
        "Sub Zone Name": sub_zone_name,
        "start Date": startDate,
        "Start Time": startTime,
        "End Date": endDate,
        "End Time": endTime,
        "Amount Type": amountType,
        "Amount Planned": amountPlanned,
        "Execution Time": executionTime,
        "Amount Supplied": amount,
        Leftover: leftover,
        "Irrigation Type": __typename,
        "Open Reason": openReason,
        "Closed Reason": closeReason,
        "Valve Open Reason": valveOpenReason,
        "Valve Close Reason": valveCloseReason,
        "Leakage Flow": leakageFlow,
        Fertigations: fertigations,
      }),
    );
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, {
      type: "array",
      bookType: "xlsx",
    });
    const excelData = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(excelData, "Program_Report.xlsx");
  };

  const getOmegaDependentByProjectId = async (projectID) => {
    setIsLoading(true);
    try {
      var OmegaIdData = JSON.stringify({
        column: "project_id",
        value: projectID,
        module: "devices_master",
      });
      const OmegaIdList = await postData(
        OmegaIdData,
        "masters/getDependentMasterList",
      );
      setIsLoading(false);
      var code = OmegaIdList.code;
      if (code == 1) {
        var mergeData = OmegaIdList.data;
        mergeData.unshift({
          id: 0,
          project_id: projectId,
          omega_id: "",
          device_name: "All",
          lat: "",
          long: "",
          active: 1,
        });
        setOmegaIdValue("All");
        setOmegaIdData(mergeData);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };
  const renderOmegaIdListItems = (item: any) => {
    return (
      <View style={styles.item}>
        {isAdd == true && (
          <Text style={styles.textItem}>{item.device_name}</Text>
        )}
        {isAdd == false && (
          <Text style={styles.textItem}>{item.device_name}</Text>
        )}
        {item.id === OmegavalueId && (
          <Icon style={styles.icon} color="black" name="Safety" size={20} />
        )}
      </View>
    );
  };

  const renderGraphOmegaIdListItems = (item: any) => {
    return (
      <View style={styles.item}>
        {isAdd == true && (
          <Text style={styles.textItem}>{item.device_name}</Text>
        )}
        {isAdd == false && (
          <Text style={styles.textItem}>{item.device_name}</Text>
        )}
        {item.id === graphOmegavalueId && (
          <Icon style={styles.icon} color="black" name="Safety" size={20} />
        )}
      </View>
    );
  };

  const renderAlertTypeList = (item: any) => {
    return (
      <View style={styles.item}>
        {isAdd == true && <Text style={styles.textItem}>{item.name}</Text>}
        {isAdd == false && <Text style={styles.textItem}>{item.name}</Text>}
        {item.value === alertTypeValue && (
          <Icon style={styles.icon} color="black" name="Safety" size={20} />
        )}
      </View>
    );
  };
  const searchFilterFunction = (text) => {
    if (text) {
      const newData = OmegeDeviceName.filter(function (item) {
        const itemData = item.OmegeDevice
          ? item.OmegeDevice.toUpperCase()
          : "".toUpperCase();
        const textData = text.toUpperCase();
        return itemData.indexOf(textData) > -1;
      });
      setFilteredDataSource(newData);
      setSearch(text);
      setPage(0);
    } else {
      setFilteredDataSource(OmegeDeviceName);
      setSearch(text);
      setPage(0);
    }
  };
  var counter = 1;
  const customStyles = {
    rows: {
      style: {
        minHeight: "30px",
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        backgroundColor: "#319ef0a3",
        minHeight: "40px",
        fontSize: 16,
        fontWeight: "600",
      },
    },
    headCells: {
      style: {
        justifyContent: "center",
        minHeight: "20px",
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
        },
      },
    },
    cells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "8px",
        justifyContent: "center",

        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          fontSize: 16,
          fontWeight: "400",
          textTransform: "Capitalize",

        },
      },
    },
  };
  const caseInsensitiveSort = (rowA, rowB) => {
    const a = rowA.date.toLowerCase();
    const b = rowB.date.toLowerCase();

    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };


  const columnsOmega = [
    {
      name: "Omega Name",
      selector: (row) => row.unitName,
    },
    {
      name: "Program Name",
      selector: (row) => row.programName,
      sortable: true,
      sortFunction: caseInsensitiveSort,
    },
    {
      name: "Valve Name",
      selector: (row) => row.valveName,
      sortable: true,
      sortFunction: caseInsensitiveSort,
    },
    {
      name: "Zone Name",
      selector: (row) => row.zone_name,
    },
    {
      name: "Sub Zone Name",
      selector: (row) => row.sub_zone_name,
    },
    {
      name: "Start Date",
      selector: (row) => row.startDate,
      sortable: true,
    },
    {
      name: "Start Time",
      selector: (row) => row.startTime,
      sortable: true,
    },
    {
      name: "End Date",
      selector: (row) => row.endDate,
      sortable: true,
    },
    {
      name: "End Time",
      selector: (row) => row.endTime,
      sortable: true,
    },
    {
      name: "Amount Type",
      selector: (row) => row.amountType,
      sortable: true,
    },
    {
      name: "Amount Planned",
      selector: (row) => row.amountPlanned,
      sortable: true,
    },
    {
      name: "Execution Time",
      selector: (row) => row.executionTime,
      sortable: true,
    },
    {
      name: "Amount Supplied",
      selector: (row) => row.amount,
      sortable: true,
    },
    {
      name: "Leftover",
      selector: (row) => row.leftover,
      sortable: true,
      sortFunction: caseInsensitiveSort,
    },
    {
      name: "Irrigation Type",
      selector: (row) => row.__typename,
      sortable: true,
      sortFunction: caseInsensitiveSort,
    },
    {
      name: "Open Reason",
      selector: (row) => row.openReason,
      sortable: true,
      sortFunction: caseInsensitiveSort,
    },
    {
      name: "Closed Reason",
      selector: (row) => row.closeReason,
      sortable: true,
      sortFunction: caseInsensitiveSort,
    },
    {
      name: "Valve Open Reason",
      selector: (row) => row.valveOpenReason,
      sortable: true,
      sortFunction: caseInsensitiveSort,
    },
    {
      name: "Valve Close Reason",
      selector: (row) => row.valveCloseReason,
      sortable: true,
      sortFunction: caseInsensitiveSort,
    },
    {
      name: "Leakage Flow",
      selector: (row) => row.leakageFlow,
      sortable: true,
      sortFunction: caseInsensitiveSort,
    },
    {
      name: "Fertigations",
      selector: (row) => row.fertigations,
      sortable: true,
      sortFunction: caseInsensitiveSort,
    },

    
  ];

  const getOmegaDeviceData = async (omegaId) => {
    setIsLoadingSync(true);
    setIsFetched(false);

    try {
      let proCodeId = await AsyncStorage.getItem("projectCode");
      let proCode = JSON.parse(proCodeId);
      let projValue = await AsyncStorage.getItem("projectAllData");
      let projectData = projValue ? JSON.parse(projValue) : null;
      var OmegeDeviceData = JSON.stringify({
        pid: proCode,
        unitId: omegaId,
        from: FromDate,
        to: ToDate,
        project_id: projectData?.id,
      });

      const OmegeDeviceNameResponse = await postData(
        OmegeDeviceData,
        "reports/irrigationLog",
      );
      var code = OmegeDeviceNameResponse.code;
      if (code == 1) {
        setOmegeDeviceNameData(OmegeDeviceNameResponse.data);
      } else {
        setOmegeDeviceNameData([]);
      }
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsLoadingSync(false);
      setIsFetched(true);
    }
  };

  const getProgramGraphData = async (omega_id) => {
    setIsLoadingSync(true);
    let projValue = await AsyncStorage.getItem("projectAllData");
    let projectData = projValue ? JSON.parse(projValue) : null;
    let from_date = moment(graphFromDate).format("YYYY-MM-DD");
    let to_date = moment(graphToDate).format("YYYY-MM-DD");
    try {
      var OmegeDeviceData = JSON.stringify({
        project_id: projectData?.id,
        startDate: from_date,
        endDate: to_date,
        omega_id: omega_id,
      });

      const programGraphResponse = await postData(
        OmegeDeviceData,
        "reports/graphIrrigationLog",
      );

      var code = programGraphResponse.code;
      if (code == 1) {
        setProgramGraphData(programGraphResponse.data);
      } else {
        setProgramGraphData(programGraphResponse.data);
        setIsLoadingSync(false);
      }
    } catch (error) {
      setIsLoadingSync(false);
    }
  };

  const getReportSync = async () => {
    setIsReportSynce(true);
    try {
      let proCodeId = await AsyncStorage.getItem("projectCode");

      let proCode = JSON.parse(proCodeId);
      let projValue = await AsyncStorage.getItem("projectAllData");
      let projectData = projValue ? JSON.parse(projValue) : null;
      const data = JSON.stringify({
        from: FromDate,
        to: ToDate,
        uid: null,
        pid: proCode,
        project_id: projectData?.id,

        isSync: true,
      });

      const OmegeDeviceNameResponse = await postData(data, "reports/programs");
      var code = OmegeDeviceNameResponse.code;
      if (OmegeDeviceNameResponse) {
        setIsReportSynce(false);
      } else {
        setIsReportSynce(false);
      }
    } catch (error) {
      setIsReportSynce(false);
      console.error("error", error);
    }
  };

  return (
    <SafeAreaView>
      <ScrollView
        showsVerticalScrollIndicator={false}
        style={{ marginBottom: "-80%" }}
      >
        <View
          style={
            isMobile
              ? [styles.container, { marginTop: "-15%" }]
              : [styles.container]
          }
        >
          <View
            style={
              isMobile
                ? {
                    flexDirection: "row",
                    width: "100%",
                    marginTop: "65%",
                    backgroundColor: "#fff",
                  }
                : {
                    flexDirection: "row",
                    width: "100%",
                    marginTop: "10%",
                    backgroundColor: "#fff",
                  }
            }
          >
            <View
              style={
                isMobile
                  ? { backgroundColor: "#fff" }
                  : { margin: 10, backgroundColor: "#fff" }
              }
            >
              <Text style={styles.lableText}>
                Reports {">"}{" "}
                <Text
                  style={{ color: "#000000" }}
                  onPress={() => navigation.navigate("Program")}
                >
                  {" "}
                  Program{" "}
                </Text>
              </Text>
            </View>
            <View
              style={
                isMobile
                  ? {
                      position: "absolute",
                      right: 0,
                      top: 50,
                      backgroundColor: "#fff",
                      left: "8%",
                    }
                  : {
                      position: "absolute",
                      right: 0,
                      top: 10,
                      backgroundColor: "#fff",
                    }
              }
            >
              <CustomSwitch
                selectionMode={1}
                roundCorner={true}
                option1={"Table View"}
                option2={"Graphical View"}
                onSelectSwitch={onSelectSwitch}
                selectionColor={"#006EB9"}
              />
            </View>
          </View>

          {!isGraphicalViewOpen ? (
            <View
              style={
                isMobile
                  ? {
                      height: "100%",
                      width: "100%",
                      backgroundColor: "#fff",
                      marginTop: 80,
                    }
                  : {
                      height: "100%",
                      width: "100%",
                      backgroundColor: "#fff",
                    }
              }
            >
              <View
                style={
                  isMobile
                    ? {
                        flexDirection: "row",
                        width: "100%",
                        marginTop: "1%",
                        marginLeft: 2,
                        backgroundColor: "#fff",
                      }
                    : {
                        flexDirection: "row",
                        width: "100%",
                        marginTop: "0%",
                        marginLeft: 20,
                        backgroundColor: "#fff",
                      }
                }
              >
                <View
                  style={
                    isMobile
                      ? { width: "45%", backgroundColor: "#fff" }
                      : { width: "20%", backgroundColor: "#fff" }
                  }
                >
                  <Text
                    style={
                      isMobile
                        ? { color: "#000000", fontSize: 12 }
                        : { color: "#000000" }
                    }
                  >
                    From Date
                  </Text>
                  <View
                    style={{
                      flexDirection: "column",
                      marginTop: 7,
                      backgroundColor: "#fff",
                    }}
                  >
                    <Text
                      style={styles.input}
                      onPress={() => setFromOpen(true)}
                    >
                      {isMobile
                        ? moment(FromDate).format("DD/MM/YY")
                        : moment(FromDate).format("DD/MM/YYYY")}
                    </Text>
                    <Text style={styles.error_text}>{FromDateError}</Text>
                  </View>
                </View>
                <DatePickerModal
                  locale="en"
                  mode="single"
                  visible={FromOpen}
                  onDismiss={onDismissFrom}
                  date={FromDate}
                  onConfirm={onConfirmFrom}
                  label="Select date" 
                  closeIcon="close"
                  calendarIcon="calendar" 
                />
                <View
                  style={
                    isMobile
                      ? {
                          width: "45%",
                          backgroundColor: "#fff",
                          marginLeft: "-10%",
                        }
                      : { width: "20%", backgroundColor: "#fff" }
                  }
                >
                  <Text
                    style={
                      isMobile
                        ? { color: "#000000", fontSize: 12 }
                        : { color: "#000000" }
                    }
                  >
                    To Date
                  </Text>
                  <View
                    style={{
                      flexDirection: "column",
                      marginTop: 7,
                      backgroundColor: "#fff",
                    }}
                  >
                    <Text style={styles.input} onPress={() => setToOpen(true)}>
                      {isMobile
                        ? moment(ToDate).format("DD/MM/YY")
                        : moment(ToDate).format("DD/MM/YYYY")}
                    </Text>
                    <Text style={styles.error_text}>{ToDateError}</Text>
                  </View>
                </View>
                <DatePickerModal
                  locale="en"
                  mode="single"
                  visible={ToOpen}
                  onDismiss={onDismissTo}
                  date={ToDate}
                  onConfirm={onConfirmTo}
                  label="Select date" 
                  closeIcon="close" 
                  calendarIcon="calendar" 
                />
                <View
                  style={
                    isMobile
                      ? {
                          width: "30%",
                          backgroundColor: "#fff",
                          marginLeft: "-10%",
                        }
                      : { width: "20%", backgroundColor: "#fff" }
                  }
                >
                  <Text
                    style={
                      isMobile
                        ? { color: "#000000", fontSize: 12 }
                        : { color: "#000000" }
                    }
                    numberOfLines={1}
                  >
                    Select Omega
                  </Text>
                  <Dropdown
                    ref={dropdownRefOmegaiD}
                    style={styles.dropdown}
                    placeholderStyle={
                      isMobile ? { fontSize: 12 } : styles.placeholderStyle
                    }
                    selectedTextStyle={styles.selectedTextStyle}
                    inputSearchStyle={styles.inputSearchStyle}
                    iconStyle={styles.iconStyle}
                    data={OmegaIdData}
                    search
                    maxHeight={300}
                    labelField="device_name"
                    valueField="device_name"
                    placeholder={!isFocus ? "Omega Device Type" : "...."}
                    searchPlaceholder="Search..."
                    value={OmegaIdValue}
                    onChange={(item) => {
                     
                      setOmegaIdValue(item.device_name);
                      setOmegaValueiD(item.id);
                      if (FromDate === undefined && ToDate === undefined) {
                        setFromDateError("Please select from data");
                        setToDateError("Please select to date");
                      } else {
                        setOmegaId(item.omega_id);
                        getOmegaDeviceData(item.omega_id);
                        setFromDateError("");
                        setToDateError("");
                      }
                    }}
                    renderItem={renderOmegaIdListItems}
                  />
                </View>
                <View style={{ marginRight: 5 }}>
                  {IsReportSynce ? (
                    <ActivityIndicator
                      color="#1DA1F2"
                      visible={IsReportSynce}
                      textContent={"Loading..."}
                      size={40}
                    />
                  ) : (
                    <View style={{ width: 25, height: 25 }}>
                      <TouchableOpacity
                        style={{
                          backgroundColor: "red",
                          margin: 15,
                          marginBottom: 20,
                        }}
                        onPress={() => getReportSync()}
                      >
                        <IconRefresh name="refresh" size={25} />
                      </TouchableOpacity>
                    </View>
                  )}
                </View>
                <View
                  style={
                    isMobile
                      ? {
                          margin: "20%",
                          alignItems: "flex-end",
                          marginTop: "25%",
                          backgroundColor: "#fff",
                          width: "65%",
                          marginLeft: "-65%",
                        }
                      : {
                          alignItems: "flex-end",
                          margin: 20,
                          flex: 1,
                          backgroundColor: "#fff",
                        }
                  }
                >
                  {OmegeDeviceName.length > 0 && (
                    <TouchableOpacity
                      style={
                        isMobile
                          ? {
                              alignItems: "center",
                              backgroundColor: "#747474",
                              padding: 10,
                              borderWidth: 1,
                              borderColor: "#747474",
                              width: "65%",
                              borderRadius: 10,
                              marginBottom: "-40%",
                            }
                          : styles.alertBtn
                      }
                      onPress={() => {
                        getDownloadExcel();
                      }}
                    >
                      <Text style={styles.btnText}>
                        <Icon name="exclefile1" size={15} color="#fff" />{" "}
                        Download
                      </Text>
                    </TouchableOpacity>
                  )}
                </View>
              </View>
              <View
                style={
                  isMobile
                    ? [
                        styles.card,
                        {
                          flexGrow: 1,
                          backgroundColor: "#fff",
                          marginTop: "-3%",
                        },
                      ]
                    : [styles.card, { flexGrow: 1, backgroundColor: "#fff" }]
                }
              >
                <View
                  style={[
                    styles.shadowProp,
                    {
                      width: "100%",
                      backgroundColor: "#F6F9F9",
                    },
                  ]}
                >
                  <View style={{ backgroundColor: "#fff" }}>
                    {isPressAlert == true && (
                      <DataTable
                        columns={columnsAlert}
                        data={filterData}
                        customStyles={customStyles}
                        pagination
                        defaultSortFieldId={"OmegeDevice"}
                        defaultSortAsc={true}
                      />
                    )}
                    {isPressOmega == true &&
                      (isLoadingSync ? (
                        <ActivityIndicator
                          color="#1DA1F2"
                          visible={isLoadingSync}
                          textContent={"Loading..."}
                          size={100}
                          
                        />
                      ) : !isFetched ? null : OmegeDeviceName.length > 0 ? (
                        <DataTable
                          columns={columnsOmega}
                          data={OmegeDeviceName}
                          customStyles={customStyles}
                          pagination
                          defaultSortFieldId={"OmegeDevice"}
                          defaultSortAsc={true}
                        />
                      ) : (
                        <View
                          style={{
                            justifyContent: "center",
                            backgroundColor: "#fff",
                          }}
                        >
                          <Text
                            style={[
                              styles.emptyListStyle,
                              {
                                alignSelf: "center",
                                marginTop: 20,
                                color: "#000000",
                              },
                            ]}
                          >
                            No Program data Found{" "}
                          </Text>
                        </View>
                      ))}
                  </View>
                </View>
              </View>
            </View>
          ) : (
            <View
              style={
                isMobile
                  ? {
                      height: "100%",
                      width: "120%",
                      marginTop: "20%",
                      backgroundColor: "#fff",
                    }
                  : {
                      height: "100%",
                      width: "100%",
                      marginBottom: 50,
                      backgroundColor: "#fff",
                    }
              }
            >
              <View
                style={{
                  margin: 20,
                  shadowColor: "#171717",
                  shadowOffset: { width: -2, height: 4 },
                  shadowOpacity: 0.2,
                  shadowRadius: 15,
                  padding: 20,
                  backgroundColor: "#fff",
                }}
              >
                <View
                  style={
                    isMobile
                      ? {
                          flexDirection: "row",
                          width: "100%",
                          marginTop: "1%",
                          marginLeft: 2,
                          backgroundColor: "#fff",
                        }
                      : {
                          flexDirection: "row",
                          width: "100%",
                          marginTop: "0%",
                          marginLeft: 20,
                          backgroundColor: "#fff",
                        }
                  }
                >
                  <View
                    style={
                      isMobile
                        ? { width: "45%", backgroundColor: "#fff" }
                        : {
                            width: "15%",
                            marginLeft: 20,
                            backgroundColor: "#fff",
                          }
                    }
                  >
                    <Text
                      style={
                        isMobile
                          ? { color: "#000000", fontSize: 12 }
                          : { color: "#000000" }
                      }
                    >
                      From Date
                    </Text>
                    <View
                      style={{
                        flexDirection: "column",
                        marginTop: 7,
                        backgroundColor: "#fff",
                      }}
                    >
                      <Text
                        style={styles.input}
                        onPress={() => setGraphFromOpen(true)}
                      >
                        {isMobile
                          ? moment(graphFromDate).format("DD/MM/YY")
                          : moment(graphFromDate).format("DD/MM/YYYY")}
                      </Text>
                      <Text style={styles.error_text}>
                        {graphFromDateError}
                      </Text>
                    </View>
                  </View>
                  <DatePickerModal
                    locale="en"
                    mode="single"
                    visible={graphFromOpen}
                    onDismiss={onDismissGraphFrom}
                    date={graphFromDate}
                    onConfirm={onConfirmGraphFrom}
                    label="Select date" 
                    closeIcon="close" 
                    calendarIcon="calendar" 
                  />
                  <View
                    style={
                      isMobile
                        ? {
                            width: "45%",
                            backgroundColor: "#fff",
                            marginLeft: "-10%",
                          }
                        : { width: "15%", backgroundColor: "#fff" }
                    }
                  >
                    <Text
                      style={
                        isMobile
                          ? { color: "#000000", fontSize: 12 }
                          : { color: "#000000" }
                      }
                    >
                      To Date
                    </Text>
                    <View
                      style={{
                        flexDirection: "column",
                        marginTop: 7,
                        backgroundColor: "#fff",
                      }}
                    >
                      <Text
                        style={styles.input}
                        onPress={() => setGraphToOpen(true)}
                      >
                        {isMobile
                          ? moment(graphToDate).format("DD/MM/YY")
                          : moment(graphToDate).format("DD/MM/YYYY")}
                      </Text>
                      <Text style={styles.error_text}>{graphToDateError}</Text>
                    </View>
                  </View>
                  <DatePickerModal
                    locale="en"
                    mode="single"
                    visible={graphToOpen}
                    onDismiss={onDismissGraphTo}
                    date={graphToDate}
                    onConfirm={onConfirmGraphTo}
                    label="Select date" 
                    closeIcon="close" 
                    calendarIcon="calendar" 
                  />

                  <View
                    style={
                      isMobile
                        ? {
                            width: "30%",
                            backgroundColor: "#fff",
                            marginLeft: "-10%",
                          }
                        : { width: "20%", backgroundColor: "#fff" }
                    }
                  >
                    <Text
                      style={
                        isMobile
                          ? { color: "#000000", fontSize: 12 }
                          : { color: "#000000" }
                      }
                      numberOfLines={1}
                    >
                      Select Omega
                    </Text>
                    <Dropdown
                      ref={dropdownRefOmegaiD}
                      style={styles.dropdown}
                      placeholderStyle={
                        isMobile ? { fontSize: 12 } : styles.placeholderStyle
                      }
                      selectedTextStyle={styles.selectedTextStyle}
                      inputSearchStyle={styles.inputSearchStyle}
                      iconStyle={styles.iconStyle}
                      data={OmegaIdData}
                      search
                      maxHeight={300}
                      labelField="device_name"
                      valueField="device_name"
                      placeholder={!isFocus ? "Omega Device Type" : "...."}
                      searchPlaceholder="Search..."
                      value={OmegaIdValue}
                      onChange={(item) => {
                        setGraphOmegaIdValue(item.device_name);
                        setGraphOmegaValueiD(item.id);
                        if (FromDate === undefined && ToDate === undefined) {
                          setFromDateError("Please select from data");
                          setToDateError("Please select to date");
                        } else {
                          setGraphOmegaId(item.omega_id);
                          getProgramGraphData(item.omega_id);
                          setFromDateError("");
                          setToDateError("");
                        }
                      }}
                      renderItem={renderGraphOmegaIdListItems}
                    />
                  </View>
                </View>
                {isLoadingSync ? (
                  <ActivityIndicator
                    color="#1DA1F2"
                    visible={isLoadingSync}
                    textContent={"Loading..."}
                    size={100}
                  />
                ) : programGraphData?.valveData !== undefined &&
                  programGraphData?.valveData?.length > 0 ? (
                  <ScrollView horizontal showsHorizontalScrollIndicator={false}>
                    <View
                      style={{
                        height: windowHeight * 0.7,
                        width: windowWidth * 0.7,
                        padding: 20,
                        backgroundColor: "#fff",
                      }}
                    >
                      <Victory.VictoryChart
                        width={
                          programGraphData.dateCountArray.length <= 3
                            ? windowWidth * 0.4
                            : windowWidth * 0.7
                        }
                        domainPadding={{ x: 50, y: 50 }}
                        theme={Victory.VictoryTheme.grayscale}
                      >
                        <Victory.VictoryAxis
                          tickValues={programGraphData.dateCountArray}
                          tickFormat={programGraphData.dateArray}
                          fixLabelOverlap
                          label={"Dates"}
                          axisLabelComponent={
                            <Victory.VictoryLabel
                              style={{
                                fill: "#455A64",
                                fontSize: 15,
                                marginTop: 20,
                              }}
                              y={windowHeight * 0.4}
                              textAnchor={"middle"}
                            />
                          }
                          style={{
                            grid: { stroke: "#D5D5D5" },
                            ticks: { stroke: "#D5D5D5", size: 5 },
                            tickLabels: { fontSize: 13, padding: 5 },
                          }}
                        />
                        <Victory.VictoryAxis
                          dependentAxis
                          fixLabelOverlap
                          tickFormat={(x) => x}
                          label={"Duration, Minutes"}
                          axisLabelComponent={
                            <Victory.VictoryLabel
                              style={{ fill: "#455A64", fontSize: 15 }}
                              x={12}
                              textAnchor={"middle"}
                            />
                          }
                          style={{
                            grid: { stroke: "#D5D5D5" },
                            ticks: { stroke: "#D5D5D5", size: 5 },
                            tickLabels: { fontSize: 13, padding: 5 },
                          }}
                        />
                        <Victory.VictoryStack
                          colorScale={programGraphData.colorData}
                        >
                          {programGraphData.valveData.map((item, index) => {
                            return (
                              <Victory.VictoryBar
                                padding={{ left: 50 }}
                                labelComponent={<Victory.VictoryTooltip />}
                                alignment="middle"
                                barRatio={0.3}
                                data={item.valve}
                                x="date"
                                y="value"
                              />
                            );
                          })}
                        </Victory.VictoryStack>
                      </Victory.VictoryChart>

                      {programGraphData.valveData.length > 0 && (
                        <View
                          style={{
                            flexDirection: "row",
                            marginBottom: 50,
                            marginTop: 20,
                          }}
                        >
                          {programGraphData.valveData.map((item, index) => {
                            return (
                              <View
                                style={{
                                  flexDirection: "row",
                                  marginStart: 20,
                                }}
                              >
                                <IconFontAwesome
                                  color={programGraphData.colorData[index]}
                                  name="square"
                                  size={20}
                                />
                                <Text
                                  style={[
                                    styles.btnTextCancel,
                                    { textAlign: "left", marginLeft: 5 },
                                  ]}
                                >
                                  {
                                    programGraphData.valveData[index].valve[0]
                                      .valveName
                                  }
                                </Text>
                              </View>
                            );
                          })}
                        </View>
                      )}
                    </View>
                  </ScrollView>
                ) : (
                  <View
                    style={{
                      height: windowHeight * 0.6,
                      width: windowWidth * 0.7,
                      backgroundColor: "#fff",
                    }}
                  >
                    <View
                      style={{
                        justifyContent: "center",
                        backgroundColor: "#fff",
                      }}
                    >
                      <Text
                        style={[
                          styles.emptyListStyle,
                          {
                            alignSelf: "center",
                            marginTop: 20,
                            color: "#000000",
                          },
                        ]}
                      >
                        No data Found
                      </Text>
                    </View>
                  </View>
                )}
              </View>
            </View>
          )}
        </View>
      </ScrollView>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
    height: "100%",
    backgroundColor: "#fff",
  },
  itemStyle: {
    padding: 10,
  },
  textInputStyle: {
    height: 35,
    borderWidth: 2,
    paddingLeft: 20,
    borderRadius: 5,
    borderColor: "#319ef0",
    backgroundColor: "#FFFFFF",
    width: "40%",
    fontWeight: "400",
  },
  tableHead: {
    fontSize: 14,
    /* FontFamily: 'Muli' ,*/
    fontWeight: "700",
    color: "#000000",
  },

  containeralt: {
    backgroundColor: "white",
    borderColor: "#eee",
    borderRadius: 10,
    borderWidth: 1,
    height: 300,
    margin: "auto",
    padding: 30,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    width: "30%",
  },
  contanerSwitch: {
    backgroundColor: "white",
    borderColor: "#eee",
    borderRadius: 5,
    alignSelf: "center",
    borderWidth: 1,
    height: "25%",
    margin: "auto",
    padding: 10,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    width: "30%",
  },
  tableHeader: {
    color: "#000",
    fontSize: 14,
    /* FontFamily: 'Muli' ,*/
    fontWeight: "400",
  },
  input: {
    borderColor: "#c3c3c3",
    width: "70%",
    borderWidth: 1,
    borderRadius: 4,
    color: "#000000",
    marginRight: 10,
    padding: 10,
    marginBottom: 6,
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
  },
  alertBtn: {
    alignItems: "center",
    backgroundColor: "#747474",
    padding: 10,
    borderWidth: 1,
    borderColor: "#747474",
    width: "33%",
    borderRadius: 10,
  },
  alertBtnAfter: {
    alignItems: "center",
    backgroundColor: "#fff",
    padding: 10,
    borderWidth: 1,
    borderColor: "#747474",
    width: "33%",
    borderRadius: 10,
  },
  saveBtn: {
    alignItems: "center",
    backgroundColor: "#006EB9",
    padding: 10,
    borderWidth: 1,
    borderColor: "#006EB9",
    width: "50%",
    marginRight: 10,
  },
  btnText: {
    color: "#fff",
    fontWeight: "600",
  },
  btnTextAfter: {
    color: "#000",
    fontWeight: "600",
  },
  card: {
    width: "100%",
    flex: 1,
    marginVertical: 10,
  },
  shadowProp: {
    shadowColor: "#171717",
    shadowOffset: { width: -2, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 15,
  },
  error_text: {
    color: "red",
    fontSize: 14,
    fontWeight: "600",
    width: "70%",
    marginLeft: 0,
    marginBottom: 10,
  },

  link: {
    marginTop: 15,
    paddingVertical: 15,
  },
  linkText: {
    fontSize: 14,
    color: "#2e78b7",
  },

  dropdown: {
    borderColor: "#c3c3c3",
    borderWidth: 1,
    borderRadius: 2,
    height: 40,
    marginLeft: 0,
    outlineStyle: "none",
    padding: 10,
    marginTop: 5,
    marginBottom: 5,

  },
  icon: {
    marginRight: 5,
  },
  item: {
    padding: 9,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  textItem: {
    flex: 1,
    fontSize: 16,
  },
  emptyListStyle: {
    padding: 20,
    fontSize: 20,
    textAlign: "center",
  },
  placeholderStyle: {
    fontSize: 16,
  },
  selectedTextStyle: {
    fontSize: 16,
  },
  iconStyle: {
    width: 20,
    height: 20,
  },
  inputSearchStyle: {
    height: 40,
    fontSize: 16,
    outlineStyle: "none",
  },
  lableText: {
    color: "#484848",
    fontWeight: "700",
    marginTop: 18,
  },
  btnTextCancel: {
    color: "#747474",
    fontWeight: "600",
    textAlign: "center",
  },
});
